import type { Request } from '../../../../index'

import {
  WarehouseStockImportParams,
  WarehouseStockImportResult,
} from 'app/common/types/warehouse/stock'

type ParamsDto = FormData

type ResultDto = {
  updated: number
  errors: Array<{ row: number; error: string }>
}

export const convertParams = (params: WarehouseStockImportParams): [ParamsDto, null] => {
  const { file } = params
  const formData = new FormData()
  formData.append('file', file)

  return [formData, null]
}

export const convertResult = ({ updated, errors }: ResultDto): WarehouseStockImportResult => {
  return { updated, errors }
}

export const POST_WAREHOUSE_STOCK_IMPORT: Request<
  WarehouseStockImportParams,
  WarehouseStockImportResult,
  void
> = ['food/warehouse/stock/import', 'post', ['data']]
